// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".myapp .thing {\n  opacity: 0.5;\n}\n", "",{"version":3,"sources":["webpack://./src/index.vue","webpack://./index.vue"],"names":[],"mappings":"AA2BA;EAEQ,YAAA;AC3BR","sourcesContent":[".myapp .thing {\n  opacity: 0.5;\n}\n",".myapp .thing {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
